import React from 'react';
import styled from 'styled-components/macro';
import { filter, lodash } from 'lodash';

import { grey50 } from 'variables/colors';
import Tag from 'components/Tag';
import { formatPhoneNumber } from 'helpers/format-phone-number';
import { border, borderRadius } from 'variables/general';
import { remove } from 'lodash-es';
import SelectButton from '../SelectButton';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  border: ${border};
  border-radius: ${borderRadius};

  &:not(:last-of-type) {
    margin-bottom: 1.5em;
  }
`;

const CoreInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1em;
  border-bottom: ${border};
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75em;
`;

const Name = styled.h5`
  margin-right: 1em;
`;

const LeftContainer = styled.div`
  flex-grow: 1;
`;

const Address = styled.h6`
  margin-bottom: 0.5em;
  color: ${grey50};
`;

const Distance = styled.h6`
  margin-top: 1em;
`;

const RightContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Details = styled.div`
  display: flex;
  padding-top: 1em;
`;

const Detail = styled.h6`
  &:not(:last-of-type)::after {
    padding: 0 1em;
    content: '|';
  }
`;

const StyledTag = styled(Tag)`
  margin-right: 1em;
  padding: 14px;
`;

const StaffCard = ({
  staff,
  selectedStaff,
  setStaffList,
  setChanges,
  setSelectedStaff,
  sortedStaff,
  isStaffList,
}) => {
  const {
    id: staffId,
    first_name: firstName,
    last_name: lastName,
    address,
    city,
    state,
    country,
    email,
    phone,
    postal_code: postalCode,
    available,
    type,
    rate,
    distance,
    travelDuration,
  } = staff || {};

  const handleToggleStaff = () => {
    setStaffList((staffListPrevState) => {
      const newState = staffListPrevState.map((staffObj) => {
        const { id, selected } = staffObj;

        if (id === staffId) {
          if (!isStaffList) {
            setSelectedStaff((prevState) =>
              prevState.filter((prevObjId) => prevObjId !== staffId),
            );
          } else {
            setSelectedStaff((prevState) => [...prevState, id]);
          }

          return {
            ...staffObj,
            selected: isStaffList ? 'selected' : 'unselected',
          };
        }

        return {
          ...staffObj,
          ...(selected
            ? {}
            : { selected: isStaffList ? 'unselected' : 'selected' }),
        };
      });

      return newState;
    });

    setChanges(true);
  };

  return (
    <Component>
      <CoreInfo>
        <LeftContainer>
          <NameContainer>
            <Name>
              {firstName} {lastName}
            </Name>

            <Tag label={type} color="primary" size="small" />
          </NameContainer>
          <Address>
            {address}, {city}, {state}, {postalCode}, {country}
          </Address>

          {distance && (
            <Distance>
              {distance} away - {travelDuration} drive
            </Distance>
          )}
        </LeftContainer>

        <RightContainer>
          <StyledTag
            label={available ? 'Available' : 'Unavailable'}
            color={available && 'primary'}
          />
          <SelectButton
            disabled={!available}
            checked={!isStaffList}
            handleToggleStaff={handleToggleStaff}
          />
        </RightContainer>
      </CoreInfo>

      <Details>
        {rate && <Detail>${rate.toFixed(2)} / hr</Detail>}
        {phone && <Detail>{formatPhoneNumber(phone)}</Detail>}
        {email && <Detail>{email}</Detail>}
      </Details>
    </Component>
  );
};
export default StaffCard;
